import React from "react";
import "./styles/ItCertificationContent.scss";
import BannerType1 from "./BannerType1";
import { useTranslation } from "react-i18next";
const ItCertificationContent = () => {
  const { t } = useTranslation();
  const contents = t("it.certification.global.contents", { returnObjects: true }) as {
    path: string;
    name: string;
    text: string;
  }[];
  return (
    <>
      <div className="it_certification_content_wrap">
        <BannerType1 path="/imgs/banner_it_certification.png" />
        <h2 className="title">{t("it.certification.global.title")}</h2>
        <div className="contents">
          <div className="des">{t("it.certification.global.des")}</div>
          <div className="card_wrap">
            {contents.map((content: { path: string; name: string; text: string }, index: number) => {
              return (
                <div className="card" key={`${content.name}_${index}`}>
                  <div className="img_box">
                    <img src={content.path} alt={content.name} />
                  </div>
                  <div className="text_wrap">
                    <div className="name">{content.name}</div>
                    <div className="text">{content.text}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItCertificationContent;
